import { IFormService } from "../../service/form/FormService";

export default class CheckRightOfAccessToDataInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(formReportingPeriodId: number, action: string) {
    return this.formService.checkRightOfAccessToData(
      formReportingPeriodId,
      action
    );
  }
}
